var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBackArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .back-arrow-class-a {\n                fill: none !important;\n            }\n\n            .back-arrow-class-b {\n                fill: #fff;\n            }\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "back-arrow-class-a",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "back-arrow-class-b",
    d: "M9,19.988l1.41-1.51L5.83,13.565H22V11.423H5.83L10.42,6.51,9,5,2,12.494Z",
    transform: "translate(0 -0.494)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBackArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_back_arrow.6770aa7a62dcd1d35dbcbef2c6630c13.svg";